import request from "@/utils/request";

//登录接口
export const login = data => {
  return request({
    url: "Login/jt_login",
    data
  });
};

//获取用户信息
export const getUserInfo = (data = {}) => {
  return request({
    url: "User/get_user_info",
    data
  });
};

//获取用户项目列表
export const getUserProjectList = () => {
  return request({
    url: "User/my_shop_lists"
  });
};

//获取个人中心我的积分
export const getUserIntegral = (data = {}) => {
  return request({
    url: "Statistics/my_integral",
    data
  });
};

//获取我的积分排名列表
export const getUserIntegralRanking = (data = {}) => {
  return request({
    url: "Statistics/integral_ranking",
    data
  });
};

//设置用户项目
export const setUserProject = (data = {}) => {
  return request({
    url: "User/my_shop_change",
    data
  });
};

//退出登录
export const logout = () => {
  return request({
    url: "Login/logout"
  });
};

// 效验用户密码
export const validatePassword = password => {
  return request({
    url: "User/check_pass",
    data: {
      old_pass: password
    }
  });
};
// 修改用户密码
export const setPassword = password => {
  return request({
    url: "User/change_pass",
    data: {
      new_pass: password
    }
  });
};

// 修改用户信息
export const setUserInfo = (data = {}) => {
  return request({
    url: "User/user_info_change",
    data
  });
};

// 修改用户账号
export const setUserAccess = password => {
  return request({
    url: "User/username_change",
    data: {
      new_pass: password
    }
  });
};
